<template>
	<db-col class="tabbar-wrapper" :height="height" valign="middle">
		<slot name="prefix"></slot>
		<db-tabbar-item :value="value" :nav="nav" v-for="(nav, idx) in navs" :key="idx" />
		<slot name="suffix"></slot>
	</db-col>
</template>

<script>
	export default {
		name: 'tabbar',
		
		props: {
			value: {
				type: [String, Number, Boolean],
				default: ''
			},
			
			height: {
				type: [String, Number],
				default: '120'
			},
			
			navs: {
				type: Array,
				default(){
					return []
				}
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.tabbar-wrapper{
		background: #fff;
		box-shadow: 0 -1px 30px rgba(#000, .15);
		z-index: 2;
		font-size: inherit;
		color: inherit;
	}
</style>
